var _linearGradient, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTimeline = function SvgTimeline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "timeline_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: -911.234,
    y1: 565.796,
    x2: -910.829,
    y2: 565.391,
    gradientTransform: "matrix(64 0 0 -64 58339 36231)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#517df8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#timeline_svg__a)",
    d: "M57 66H9c-4.962 0-9-4.037-9-9V9c0-4.962 4.038-9 9-9h48c4.963 0 9 4.038 9 9v48c0 4.963-4.037 9-9 9zM9 2C5.14 2 2 5.14 2 9v48c0 3.859 3.14 7 7 7h48c3.859 0 7-3.141 7-7V9c0-3.86-3.141-7-7-7H9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0B0C13",
    d: "M45 34H34v-2h7c1.654 0 3-1.346 3-3v-5c0-1.654-1.346-3-3-3h-7v-3a1 1 0 00-2 0v3H21c-1.654 0-3 1.346-3 3v5c0 1.654 1.346 3 3 3h11v2h-7c-1.654 0-3 1.346-3 3v5c0 1.654 1.346 3 3 3h7v3a1 1 0 002 0v-3h11c1.654 0 3-1.346 3-3v-5c0-1.654-1.346-3-3-3zm-4-11c.552 0 1 .449 1 1v5c0 .551-.448 1-1 1h-7v-7h7zm-20 7c-.551 0-1-.449-1-1v-5c0-.551.449-1 1-1h11v7H21zm4 13c-.551 0-1-.448-1-1v-5c0-.552.449-1 1-1h7v7h-7zm21-1a1 1 0 01-1 1H34v-7h11a1 1 0 011 1v5z"
  })));
};
export default SvgTimeline;